var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDinersClub({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h100v60H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0079BE",
    d: "M54.328 47.929c9.731.047 18.613-8.009 18.613-17.809 0-10.716-8.882-18.124-18.613-18.12h-8.375C36.106 11.996 28 19.406 28 30.12c0 9.802 8.106 17.856 17.953 17.809h8.375z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M45.993 13.485c-8.999.003-16.29 7.363-16.293 16.447.003 9.083 7.294 16.443 16.293 16.446 9-.003 16.294-7.363 16.295-16.446-.001-9.084-7.294-16.444-16.295-16.447zM35.666 29.932a10.438 10.438 0 016.63-9.728v19.455a10.434 10.434 0 01-6.63-9.727zm14.023 9.731v-19.46a10.433 10.433 0 016.634 9.73 10.436 10.436 0 01-6.634 9.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0079BE",
    d: "M54.328 47.929c9.731.047 18.613-8.009 18.613-17.809 0-10.716-8.882-18.124-18.613-18.12h-8.375C36.106 11.996 28 19.406 28 30.12c0 9.802 8.106 17.856 17.953 17.809h8.375z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M45.993 13.485c-8.999.003-16.29 7.363-16.293 16.447.003 9.083 7.294 16.443 16.293 16.446 9-.003 16.294-7.363 16.295-16.446-.001-9.084-7.294-16.444-16.295-16.447zM35.666 29.932a10.438 10.438 0 016.63-9.728v19.455a10.434 10.434 0 01-6.63-9.727zm14.023 9.731v-19.46a10.433 10.433 0 016.634 9.73 10.436 10.436 0 01-6.634 9.73z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinersClub);
export default __webpack_public_path__ + "static/media/diners-club.9b08d4385696d2e1763079a1ee81c0fe.svg";
export { ForwardRef as ReactComponent };